import { FormControl, FormControlLabel, FormHelperText, FormLabel, Icon, Radio, RadioGroup } from '@mui/material';
import { useField } from 'formik';

export default function RadioField({ boldLabel, ...props }) {
    const [field, meta, helper] = useField(props.name);

    const handleChange = event => {
        if (props.onChange) props.onChange(event);

        helper.setValue(event.target.value);
    };

    return (
        <FormControl sx={{ width: '100%', m: '8px 0' }} error={!!meta.error}>
            {props.label && (
                <FormLabel
                    sx={theme => ({
                        fontSize: theme.typography.pxToRem(16),
                        m: 0,
                        lineHeight: '24px',
                        letterSpacing: '0.15px',
                        fontWeight: boldLabel ? theme.typography.fontWeightMedium : theme.typography.fontWeightRegular
                    })}
                >
                    {props.label}
                </FormLabel>
            )}
            <RadioGroup
                {...props}
                value={field.value ?? ''}
                name={props.name}
                sx={{ span: { color: 'common.black' } }}
                aria-labelledby={`${props.name}-radio-group`}
                onChange={handleChange}
            >
                {props.options.map((option, index) => (
                    <FormControlLabel
                        key={index}
                        sx={{ mb: 0 }}
                        disabled={option.disabled}
                        value={option.value ?? ''}
                        control={
                            <Radio
                                icon={<Icon>radio_button_unchecked</Icon>}
                                checkedIcon={
                                    <Icon
                                        sx={theme => ({
                                            color: `${theme.palette.success.main} !important`
                                        })}
                                    >
                                        radio_button_checked
                                    </Icon>
                                }
                            />
                        }
                        label={option.label}
                    />
                ))}
            </RadioGroup>
            {meta.error && <FormHelperText>{meta.error}</FormHelperText>}
        </FormControl>
    );
}
